import { LogManager } from '../../../../common/port/log/log.manager.port';
import { AccountAverageWorkingHoursPerPersonRangesAggregateRootMapper } from '../../../../infrastructure/mappers/org-metrics/working-hours/account-average-working-hours-per-person-distribution-range.aggregate-root.mapper';
import { GetAccountAverageWorkingHoursPerPersonRangesRequestDto } from '../../../dtos/org-metrics/working-hours/get-account-average-working-hours-per-person-ranges.request.dto';
import { GetAccountAverageWorkingHoursPerPersonRangesResponseDto } from '../../../dtos/org-metrics/working-hours/get-account-average-working-hours-per-person-ranges.response.dto';
import { GetAccountAverageWorkingHoursPerPersonRangesQuery } from '../../../queries/org-metrics/working-hours/get-account-average-working-hours-per-person-ranges.query';

export class GetAccountAverageWorkingHoursPerPersonRangesController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountAverageWorkingHoursPerPersonRangesQuery,
    protected readonly mapper: AccountAverageWorkingHoursPerPersonRangesAggregateRootMapper
  ) {}

  async get(
    props: GetAccountAverageWorkingHoursPerPersonRangesRequestDto
  ): Promise<GetAccountAverageWorkingHoursPerPersonRangesResponseDto> {
    try {
      const result = await this.query.execute(props);
      return result.map((res) => this.mapper.toResponse(res));
    } catch (error) {
      throw new Error(
        `GetAccountAverageWorkingHoursPerPersonRangesController.get encountered an error ${error}`
      );
    }
  }
}
